import { render, staticRenderFns } from "./viewBOSTF.vue?vue&type=template&id=0867f7ba&scoped=true"
import script from "./viewBOSTF.vue?vue&type=script&lang=js"
export * from "./viewBOSTF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0867f7ba",
  null
  
)

export default component.exports